import {observer} from "mobx-react-lite";
import { PlanStore } from "../../../../subscription-plans/stores/subscription-plans-store";
import "./onboarding-plan-short-description.scss";

export interface IPlanShortDescription {
    plan: PlanStore;
}

const OnboardingPlanShortDescription: React.FC<IPlanShortDescription> = observer(({ plan }) => (
    <div className={`onboarding-plan-short-description`} dangerouslySetInnerHTML={{__html: plan.short_description ?? ''}} />
));

export default OnboardingPlanShortDescription;